import React from 'react';
import styled from 'styled-components';

interface EmptyStateProps {
  message?: string;
  children?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  children
}) => <Wrapper>{children || message || 'No data available'}</Wrapper>;

const Wrapper = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: var(--ink-faint);
  font-size: 14px;
`;
